module.exports = __webpack_public_path__ + "img/5-detail.02edcc53.jpg";